import React from 'react';
import PropTypes from 'prop-types';
import { Segment } from 'semantic-ui-react';

import AssetTable from '../asset-table';

const CampaignDashboardTable = props => {
  const { assets } = props;
  return (
    <Segment><AssetTable assets={assets} /></Segment>
  );
};

CampaignDashboardTable.propTypes = {
  assets: PropTypes.array.isRequired,
};


export default CampaignDashboardTable;



/** WEBPACK FOOTER **
 ** ./src/components/campaign-dashboard-table/index.js
 **/